import { graphql } from '@/gql';
import type { ReactivatePartnerCallerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const reactivatePartnerCaller = async ({ callerId, periodEndAt }: ReactivatePartnerCallerMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      periodEndAt,
    },
    mutation: graphql(`
      mutation ReactivatePartnerCaller($callerId: String!, $periodEndAt: String!) {
        reactivatePartnerCaller(callerId: $callerId, periodEndAt: $periodEndAt) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
        }
      }
    `),
  });

  return response.data?.reactivatePartnerCaller;
};
